import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import MuiContainer from '@mui/material/Container'

export const Container = styled(MuiContainer)(() => ({
  maxWidth: '700px',
  padding: '48px 48px 60px 48px',
  marginTop: '32px',
  fontSize: '24px',
  lineHeight: '32px',
  border: `1px solid rgba(0, 0, 0, 0.12)`,
  backgroundColor: '#FFFFFF',
}))

export const Title = styled(Typography)(() => ({
  marginBottom: '24px',
  paddingBottom: '24px',
  borderBottom: `1px solid rgba(0, 0, 0, 0.12)`,
  textAlign: 'left',
  fontSize: '24px',
  lineHeight: '32px',
  fontWeight: 500,
}))

export const Paper = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.25px',
  color: 'rgba(0, 0, 0, 0.6)',
  '& a': { color: theme.tokens.ThemeColorCommonSecondary },
  '& h4': { margin: 0, color: 'rgba(0, 0, 0, 0.87)' },
  '& h3': { color: 'rgba(0, 0, 0, 0.87)' },
  '& h2': { color: 'rgba(0, 0, 0, 0.87)' },
  '& p': {
    marginTop: 0,
    marginBottom: '24px',
  },
  '& p strong': { color: 'rgba(0, 0, 0, 0.87)' },
  '& li strong': { color: 'rgba(0, 0, 0, 0.87)' },
}))
